import { z } from 'zod';
import { NumberFormatting, Validation } from '@mews/framework';

export enum RateExcludingProductsFormKeys {
    currency = 'currency',
    perNight = 'perNight',
    perNightValue = '.value',
    reason = 'reason',
}

const perNightSchema = (numberLocalizationInfo: NumberFormatting) =>
    z.object({
        productOrderIds: z.array(z.string()),
        consumedUtc: z.string(),
        startUtc: z.string().nullable(),
        value: Validation.Number.LocalizedCurrencyNumber(numberLocalizationInfo).pipe(
            z
                .number()
                .min(0)
                .transform((val) => val.toString())
        ),
        enabled: z.boolean(),
        proRataStartUtc: z.string().nullable().optional(),
        proRataEndUtc: z.string().nullable().optional(),
    });

export const rateExcludingProductsFormSchema = (numberLocalizationInfo: NumberFormatting) =>
    z.object({
        [RateExcludingProductsFormKeys.currency]: Validation.String.Required,
        [RateExcludingProductsFormKeys.perNight]: z.array(perNightSchema(numberLocalizationInfo)),
        [RateExcludingProductsFormKeys.reason]: Validation.String.Required,
    });

export type RateExcludingProductsFormValues = z.infer<ReturnType<typeof rateExcludingProductsFormSchema>>;
